import { TableCell, TableRow, Typography } from '@mui/material'
import { PrefixInput } from '../custom-setting.styles'

interface IProps {
  title: string
  prefix: string
  startNumber: string
  prefixError?: string
  startNumberError?: string
  onPrefixChange: (value: string) => void
  onStartNumberChange: (value: string) => void
  onStartNumberBlur: () => void
}

const CustomSettingCode = ({
  title,
  prefix,
  startNumber,
  prefixError,
  startNumberError,
  onPrefixChange,
  onStartNumberChange,
  onStartNumberBlur,
}: IProps) => {
  return (
    <TableRow>
      <TableCell sx={{ py: 2.5, borderColor: '#eaecf0' }}>
        <Typography fontWeight={600}>{title}</Typography>
      </TableCell>
      <TableCell sx={{ py: 2.5, borderColor: '#eaecf0' }}>
        <PrefixInput
          size="small"
          value={prefix}
          onChange={(event) => onPrefixChange(event.target.value)}
          onKeyDown={(event) => {
            if (
              event.key === '-' ||
              event.key === 'Minus' ||
              event.key === 'Subtract'
            ) {
              event.preventDefault()
            }
          }}
          error={Boolean(prefixError)}
          helperText={prefixError}
          inputProps={{
            maxLength: 10,
            'aria-label': `${title} prefix`,
          }}
        />
      </TableCell>
      <TableCell sx={{ py: 2.5, borderColor: '#eaecf0' }}>
        <PrefixInput
          size="small"
          value={startNumber}
          onChange={(event) => onStartNumberChange(event.target.value)}
          onBlur={onStartNumberBlur}
          error={Boolean(startNumberError)}
          helperText={startNumberError}
          inputProps={{
            inputMode: 'numeric',
            maxLength: 6,
            'aria-label': `${title} start number`,
          }}
        />
      </TableCell>
    </TableRow>
  )
}

export default CustomSettingCode
